export function accountDestination(user) {
  if (!user) return { name: 'login' };

  if (!user.email_verified_at) {
    return { name: 'verify-email' };
  }

  if (user.status === 'pending') {
    return { name: 'pending-approval' };
  }

  if (['suspended', 'rejected'].includes(user.status)) {
    return { name: 'account-unavailable' };
  }

  return { name: 'dashboard' };
}
